<template>
    <v-container class="busy-hour">
        <v-row>
            <v-col cols="12">
                <v-select class="select" return-object v-model="reportType" color="#c42111" :items="reportTypes" @change="onChange" />
                <v-select class="select" return-object v-model="granularity" color="#c42111" :items="granularityOptions" @change="onChange" :disabled="disableControls" label="Busy hour granularity" />
                <v-select class="select" return-object v-model="metric" color="#c42111" :items="metricOptions" @change="onChange" :disabled="disableControls" label="Metric" :rules="[validation.metricRequiredForBusyHour(reportType, metric)]" />
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'DynamicBusyHour',
    props: ['param'],
    data: () => ({
        reportType: null,
        granularity: null,
        metric: null,
        reportTypes: [],
        granularityOptions: [],
        metricOptions: [],
        validation: {
            metricRequiredForBusyHour: (reportType, metric) => ((!reportType || !(reportType.value == 'daily_busy_hour' || reportType.value == 'busy_hour' || reportType.value == 'weekly_busy_hour') || !metric || !!metric.text) || `You must select a metric`)
      },
    }),

    computed: {
        disableControls: function() {
            return !(this.reportType && (this.reportType.value == 'busy_hour' || this.reportType.value == 'daily_busy_hour' || this.reportType.value == 'weekly_busy_hour'));
        }
    },

    methods: {
        onChange: function(val) {
            let selectedValue = `{"report_type":"${this.reportType.value}","busy_hour_granularity":"${this.granularity.value}","metric":"${this.metric.value}"}`;
            this.param.selectedValue = selectedValue;
            if(this.reportType.value == 'busy_hour' || this.reportType.value == 'daily_busy_hour') {
                this.param.humanText = `Top ${this.reportType.text}, granularity ${this.granularity.text}, using metric ${this.metric.text}`;
            }
            else {
                this.param.humanText = this.reportType.text;
            }

            this.$emit('edit');
        },

        buildLists: function() {
            let paramValues = this.param.rpt_param_values.slice(0);
            paramValues = JSON.parse(paramValues[0]);
            const formatList = function(items) {
                let out = [];
                for(let item of items) {
                    out.push({text: item[0], value: item[1]});
                }
                return out;
            }
            this.reportTypes = formatList(paramValues.report_type.items);
            this.granularityOptions = formatList(paramValues.busy_hour_granularity.items);
            this.metricOptions = formatList(paramValues.metric.items);
            this.reportType = this.reportTypes[0];
            this.granularity = this.granularityOptions[0];
            this.metric = this.metricOptions[0];
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            const value = JSON.parse(this.$props.param.encodedValue);
            this.reportTypes.forEach(item => {
                if(item.value == value.report_type) {
                    this.reportType = item;
                }
            });
            this.granularityOptions.forEach(item => {
                if(item.value == value.busy_hour_granularity) {
                    this.granularity = item;
                }
            });
            this.metricOptions.forEach(item => {
                if(item.value == value.metric) {
                    this.metric = item;
                }
            });
        }
    },

    mounted() {
        this.buildLists();
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>

    .busy-hour .select {
        display: inline-block;
        margin-right: 1em;
        width: calc((100% / 3) - 1em);
    }

    .busy-hour .text {
        margin-left: 1em;
        margin-right: 1em;
        margin-top: 1em;
        font-style: italic;
    }

</style>

